import { useLocale } from "../i18n/context";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/layout/Footer";
import { Hero } from "../components/layout/Hero";
import { MapSidebar } from "../components/layout/MapSidebar";

export function NaudotosPadangosPage() {
  const { t } = useLocale();

  return (
    <>
      <Header />
      <Hero title={t.common.heroTitle} subtitle={t.common.heroSubtitle} />

      <div className="flex max-w-[1200px] mx-auto my-10 px-5 gap-[30px] max-md:flex-col max-md:my-5 max-md:gap-5">
        <main
          className="flex-[2] bg-white p-10 shadow-[0_2px_10px_rgba(0,0,0,0.1)] max-md:p-5"
          dangerouslySetInnerHTML={{ __html: t.naudotosHtml }}
        />

        <MapSidebar />
      </div>

      <Footer />
    </>
  );
}
